module.exports = __webpack_public_path__ + "img/5b7f80888280d915456ec136d1e18b1.b9a4cfd0.jpg";